import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, InputLabel, Select } from '@material-ui/core';
import styles from '../constants/styles';

interface RBISelectUncontrolledProps {
  label: string;
  name: string;
  options: any[];
  defaultValue?: number | string;
  required?: boolean;
  disabled?: boolean;
}

const RBISelectUncontrolled = ({
  label,
  name,
  options,
  defaultValue = '',
  required = false,
  disabled = false,
}: RBISelectUncontrolledProps) => {
  const classes = styles();
  const { control, errors } = useFormContext();
  return (
    <Controller
      as={
        <FormControl
          variant="outlined"
          className={classes.formControl}
          size="small"
          required={required}
          error={errors[name]}
          fullWidth
        >
          <InputLabel htmlFor={`select-${name}`}>{label}</InputLabel>
          <Select
            disabled={disabled}
            native
            label={label}
            required={required}
            inputProps={{
              name: name,
              id: `select-${name}`,
            }}
            defaultValue={defaultValue}
          >
            <option></option>
            {options.map(option => (
              renderOption(option)
            ))}
          </Select>
        </FormControl>
      }
      name={name}
      rules={{ required: required && `${label} is required.` }}
      defaultValue={defaultValue}
      control={control}
    />
  );

  function renderOption(option: any) {
    if(typeof option == 'string'){
      return <option value={option}>
        {option}
      </option>;
    }else{
      return <option value={option?.value}>
        {option?.name}
      </option>;
    }
  }
};

export default RBISelectUncontrolled;
